/* MavoStudio – Farb-Konfigurator (snippets/mavo-diy-designer.liquid, Texte dort)
   - eine Farbauswahl für 1, 2 oder 4 Farben: Feld antippen, dann Farbe; Paletten füllen alle Felder
   - DIY-Kit: Mosaikfarbe #1/#2 = Varianten (1 Farbe = beide gleich), #3/#4 = Bestell-Eigenschaften
   - Fertige Untersetzer (data-mode="properties"): alle Farben + gelegtes Muster = Bestell-Eigenschaften
   - Fugenfarbe (beide): Bestell-Eigenschaft „Fugenfarbe“, färbt die Fugen in Vorschau und 3D
   Farbcodes & 3D-Bühne: assets/mavo-colors.js */
if (!window.mavoDesignerReady && window.mavoColors && document.querySelector('[data-mavo-designer]')) {
  window.mavoDesignerReady = true;
  const { solid, flatten, infoFor, setText, mountStage, showStage } = window.mavoColors;
  const ROOT = document.querySelector('[data-mavo-designer]');
  const PROPS = ROOT.dataset.mode === 'properties';
  const state = {
    mode: 2,
    active: 1,
    filled: new Set(), // Felder, die die Kundin selbst gewählt hat (die Startvariante zählt nicht)
    remembered2: '', // Farbe 2 merken, wenn kurz auf „1 Farbe“ umgestellt wird
    patterns: {
      1: ['1111111111111111', '1111111111111111'],
      2: ['1212212112122121', '2222211221122222'],
      // 4 Farben – angeordnet wie der Untersetzer auf dem MAVO-Foto (2. Untersetzer um 90° gedreht)
      4: ['1234342123141432', '1231434231232414'],
    },
  };
  const listeners = new Set();
  const notify = () => listeners.forEach((fn) => fn());
  const groutField = document.querySelector('[data-mavo-grout-field]');
  const groutStart = document.querySelector('[data-mavo-grout].is-current') || document.querySelector('[data-mavo-grout]');
  state.grout = groutStart ? { name: groutStart.dataset.mavoGrout, hex: groutStart.dataset.hex } : null;

  const mosaic = () => document.querySelector('[data-mavo-mosaic]');
  const extraInput = (slot) => document.querySelector(`[data-mavo-extra="${slot}"]`);
  const variantInputs = (slot) =>
    Array.from(document.querySelectorAll(`variant-selects input[data-option-name="Mosaikfarbe #${slot}"]`));

  // ---------- Auswahl lesen & setzen ----------
  const valueOf = (slot) => {
    if (slot <= 2 && !PROPS) {
      const input = variantInputs(slot).find((element) => element.checked);
      return input ? input.value : '';
    }
    const input = extraInput(slot);
    return input ? input.value : '';
  };

  const slotInfo = (slot) => ({ slot, ...infoFor(valueOf(state.mode === 1 && slot === 2 ? 1 : slot)) });

  const isFilled = (slot) => (slot <= 2 && !PROPS ? state.filled.has(slot) : Boolean(valueOf(slot)));

  // Mosaikfarbe #1/#2 (Varianten) setzen und den Theme-Variantenwechsel auslösen
  const setVariant = (first, second) => {
    if (PROPS) {
      if (first) setExtra(1, first);
      if (second) setExtra(2, second);
      document.body.classList.add('mavo-colors-selected');
      return;
    }
    let changed = null;
    [[1, first], [2, second]].forEach(([slot, name]) => {
      if (!name) return;
      const input = variantInputs(slot).find((element) => element.value === name);
      if (input && !input.checked) {
        input.checked = true;
        changed = input;
      }
    });
    document.body.classList.add('mavo-colors-selected');
    if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const setExtra = (slot, name) => {
    const input = extraInput(slot);
    if (input) input.value = name || '';
  };

  // ---------- Anzeige ----------
  const syncColors = () => {
    const box = mosaic();
    if (!box) return;
    const names = [];
    for (let slot = 1; slot <= 4; slot++) {
      const info = slotInfo(slot);
      if (info.hex) {
        box.style.setProperty(`--mavo-tile-${slot}`, solid(info.hex));
      } else if (info.url) {
        box.style.setProperty(`--mavo-tile-${slot}`, `url('${info.url}')`);
        box.style.setProperty(`--mavo-tile-${slot}-size`, info.size);
        box.style.setProperty(`--mavo-tile-${slot}-pos`, info.pos);
      } else {
        box.style.removeProperty(`--mavo-tile-${slot}`);
      }
      if (slot <= state.mode && info.name && !names.includes(info.name)) names.push(info.name);
    }
    box.setAttribute('aria-label', `Vorschau deiner Untersetzer in ${names.join(', ') || 'deinen Farben'}`);
  };

  const applyPattern = () => {
    document.querySelectorAll('[data-mavo-coaster]').forEach((coaster) => {
      const pattern = state.patterns[state.mode][Number(coaster.dataset.mavoCoaster)] || '';
      Array.from(coaster.children).forEach((tile, cell) => {
        tile.className = `mavo-mosaic__tile mavo-mosaic__tile--${pattern[cell] || '1'}`;
      });
    });
  };

  const syncSlots = () => {
    document.querySelectorAll('[data-mavo-slot]').forEach((button) => {
      const slot = Number(button.dataset.mavoSlot);
      const shown = slot <= state.mode;
      button.hidden = !shown;
      if (!shown) return;
      const info = slotInfo(slot);
      const active = slot === state.active;
      button.classList.toggle('is-active', active);
      button.classList.toggle('is-empty', !info.name);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = button.querySelector('[data-mavo-slot-label]');
      const name = button.querySelector('[data-mavo-slot-name]');
      const dot = button.querySelector('.mavo-slot__dot');
      const title = state.mode === 1 ? 'Deine Farbe' : `Farbe ${slot}`;
      setText(label, title);
      setText(name, info.name || 'noch offen');
      if (dot) dot.style.background = info.hex || '';
      button.setAttribute('aria-label', `${title}: ${info.name || 'noch offen'}${active ? ' – wird gerade gewählt' : ''}`);
    });
    const slots = document.querySelector('[data-mavo-slots]');
    if (slots) slots.dataset.mode = String(state.mode);
    const prompt = document.querySelector('[data-mavo-prompt]');
    const key = `${state.mode}:${state.active}`;
    if (prompt && prompt.dataset.key !== key) {
      prompt.dataset.key = key;
      prompt.innerHTML = state.mode === 1
        ? '<strong>Wähle deine Farbe</strong>'
        : `<strong>Wähle Farbe ${state.active}</strong><span> · für ein anderes Feld oben antippen</span>`;
    }
  };

  const syncGrid = () => {
    const chosen = {};
    for (let slot = 1; slot <= state.mode; slot++) {
      const name = valueOf(state.mode === 1 ? 1 : slot);
      if (name) (chosen[name] = chosen[name] || []).push(slot);
    }
    const current = valueOf(state.mode === 1 ? 1 : state.active);
    document.querySelectorAll('[data-mavo-color]').forEach((button) => {
      const name = button.dataset.mavoColor;
      const dot = button.querySelector('.mavo-color__dot');
      if (dot) flatten(dot, name);
      const slots = chosen[name] || [];
      const badges = button.querySelector('.mavo-color__badges');
      if (badges) {
        const key = `${state.mode}:${slots.join(',')}`;
        if (badges.dataset.key !== key) {
          badges.dataset.key = key;
          badges.innerHTML = (state.mode === 1 ? (slots.length ? ['✓'] : []) : slots)
            .map((label) => `<span class="mavo-color__badge">${label}</span>`)
            .join('');
        }
      }
      const isCurrent = name === current;
      button.classList.toggle('is-current', isCurrent);
      button.classList.toggle('is-used', slots.length > 0);
      button.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        slots.length && state.mode > 1 ? `${name} – gewählt als Farbe ${slots.join(' und ')}` : name
      );
    });
  };

  const syncPalettes = () => {
    const chosen = [1, 2, 3, 4].map(valueOf);
    document.querySelectorAll('[data-mavo-palette]').forEach((chip) => {
      const count = Number(chip.dataset.count || 2);
      let active = count === state.mode;
      for (let slot = 1; active && slot <= count; slot++) {
        active = chip.getAttribute(`data-color-${slot}`) === chosen[slot - 1];
      }
      chip.classList.toggle('is-active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      chip.querySelectorAll('.mavo-palette__tile').forEach((tile, i) => flatten(tile, chip.getAttribute(`data-color-${i + 1}`)));
    });
  };

  const syncModeUi = () => {
    document.querySelectorAll('[data-mavo-count]').forEach((button) => {
      const on = Number(button.dataset.mavoCount) === state.mode;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    [1, 2, 3, 4].forEach((slot) => {
      const input = extraInput(slot);
      if (input) input.disabled = (PROPS ? slot > state.mode : state.mode !== 4) || !input.value;
    });
    setText(document.querySelector('[data-mavo-count-hint]'), ROOT.getAttribute(`data-hint-${state.mode}`) || '');
    setText(document.querySelector('[data-mavo-mosaic-hint]'), ROOT.dataset[state.mode === 1 ? 'mosaicHintOne' : 'mosaicHint'] || '');
    document.body.classList.toggle('mavo-mode-4', state.mode === 4);
    document.body.classList.toggle('mavo-mode-1', state.mode === 1);
  };

  const showError = (missing) => {
    const error = document.querySelector('[data-mavo-error]');
    if (!error) return;
    error.hidden = !missing || !missing.length;
    if (missing && missing.length) {
      const fallback = state.mode === 4 && missing.every((s) => s > 2) ? ' – oder stell auf 2 Farben um' : '';
      setText(error, `Bitte wähle noch ${missing.map((s) => `Farbe ${s}`).join(' und ')}${fallback}.`);
    }
  };

  // Fertige Untersetzer: gelegtes Muster lesbar in die Bestellung („Reihe 1: 1-2-1-2 …“, 1 = erste Farbe usw.)
  const syncPatterns = () => {
    document.querySelectorAll('[data-mavo-pattern]').forEach((input) => {
      const names = [1, 2, 3, 4].map((slot) => valueOf(state.mode === 1 ? 1 : slot) || 'noch offen');
      const pattern = state.patterns[state.mode][Number(input.dataset.mavoPattern)] || '';
      const rows = [0, 1, 2, 3].map((r) => `Reihe ${r + 1}: ${pattern.slice(r * 4, r * 4 + 4).split('').join('-')}`);
      const legend = names.slice(0, state.mode).map((name, i) => `${i + 1} = ${name}`).join(', ');
      input.value = state.mode === 1 ? `alle 16 Steine ${names[0]}` : `${rows.join(' · ')} (${legend})`;
    });
  };

  const syncGrout = () => {
    if (!state.grout) return;
    document.querySelectorAll('[data-mavo-grout]').forEach((button) => {
      const on = button.dataset.mavoGrout === state.grout.name;
      button.classList.toggle('is-current', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    setText(document.querySelector('[data-mavo-grout-name]'), state.grout.name);
    if (groutField) groutField.value = state.grout.name;
    const box = mosaic();
    if (box) box.style.setProperty('--mavo-grout', state.grout.hex);
  };

  const syncAll = () => {
    syncGrout();
    syncModeUi();
    syncColors();
    syncSlots();
    syncGrid();
    syncPalettes();
    syncPatterns();
    notify();
  };

  // nächstes Feld, das noch nicht gewählt wurde (erst nach dem aktuellen, dann davor)
  const nextOpenSlot = (from) => {
    for (let step = 1; step < state.mode; step++) {
      const slot = ((from - 1 + step) % state.mode) + 1;
      if (!isFilled(slot)) return slot;
    }
    return 0;
  };

  const setMode = (mode) => {
    const previous = state.mode;
    state.mode = [1, 2, 4].includes(mode) ? mode : 2;
    if (state.mode === 1 && previous !== 1) {
      const first = valueOf(1), second = valueOf(2);
      if (second && second !== first) state.remembered2 = second;
      setVariant(null, first);
    } else if (previous === 1 && state.mode !== 1) {
      if (state.remembered2 && state.remembered2 !== valueOf(1)) setVariant(null, state.remembered2);
      else state.filled.delete(2);
    }
    if (state.mode === 1 || state.active > state.mode) state.active = 1;
    if (state.mode > 1 && isFilled(state.active)) state.active = nextOpenSlot(state.active) || state.active;
    if (state.mode !== previous) document.body.classList.add('mavo-colors-selected');
    showError(null);
    applyPattern();
    syncAll();
  };

  const setActiveSlot = (slot) => {
    state.active = Math.min(Math.max(1, slot), state.mode);
    syncAll();
  };

  const pickColor = (name) => {
    const slot = state.mode === 1 ? 1 : state.active;
    if (state.mode === 1) {
      setVariant(name, name);
      state.filled.add(1).add(2);
      state.remembered2 = '';
    } else if (slot <= 2) {
      setVariant(slot === 1 ? name : null, slot === 2 ? name : null);
      state.filled.add(slot);
    } else {
      setExtra(slot, name);
      document.body.classList.add('mavo-colors-selected');
    }
    if (state.mode > 1) state.active = nextOpenSlot(slot) || slot;
    showError(null);
    syncAll();
  };

  const cycleTile = (coasterIndex, cell) => {
    const patterns = state.patterns[state.mode];
    const pattern = patterns[coasterIndex] || '';
    const next = String((Number(pattern[cell] || 1) % state.mode) + 1);
    patterns[coasterIndex] = pattern.slice(0, cell) + next + pattern.slice(cell + 1);
    const coaster = document.querySelector(`[data-mavo-coaster="${coasterIndex}"]`);
    const tile = coaster && coaster.children[cell];
    if (tile) {
      tile.className = `mavo-mosaic__tile mavo-mosaic__tile--${next}`;
      void tile.offsetWidth;
      tile.classList.add('is-flipped');
    }
    syncPatterns();
    notify();
  };

  const pickPalette = (chip) => {
    const count = Number(chip.dataset.count || 2) === 4 ? 4 : 2;
    const colors = [1, 2, 3, 4].map((slot) => chip.getAttribute(`data-color-${slot}`) || '');
    state.remembered2 = '';
    state.mode = count;
    if (count === 4) {
      setExtra(3, colors[2]);
      setExtra(4, colors[3]);
    }
    state.filled = new Set([1, 2]);
    state.active = 1;
    showError(null);
    applyPattern();
    setVariant(colors[0], colors[1]);
    syncAll();
  };

  window.mavoDesigner = {
    getState: () => ({
      mode: state.mode,
      patterns: state.patterns[state.mode].slice(),
      colors: [1, 2, 3, 4].map(slotInfo),
      grout: state.grout ? state.grout.hex : '',
    }),
    cycleTile,
    showStage,
    subscribe: (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
  };

  document.addEventListener('click', (event) => {
    const tile = event.target.closest('.mavo-mosaic__tile');
    if (tile) {
      const coaster = tile.closest('[data-mavo-coaster]');
      if (coaster) cycleTile(Number(coaster.dataset.mavoCoaster), Array.from(coaster.children).indexOf(tile));
      return;
    }
    const count = event.target.closest('[data-mavo-count]');
    if (count) return setMode(Number(count.dataset.mavoCount));
    const grout = event.target.closest('[data-mavo-grout]');
    if (grout) {
      state.grout = { name: grout.dataset.mavoGrout, hex: grout.dataset.hex };
      syncGrout();
      notify();
      return;
    }
    const slot = event.target.closest('[data-mavo-slot]');
    if (slot) return setActiveSlot(Number(slot.dataset.mavoSlot));
    const color = event.target.closest('[data-mavo-color]');
    if (color) return pickColor(color.dataset.mavoColor);
    if (event.target.closest('[data-mavo-goto-3d]')) return showStage();
    const chip = event.target.closest('[data-mavo-palette]');
    if (chip) pickPalette(chip);
  });

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) syncAll();
  });

  // 4 Farben gewählt, aber #3/#4 fehlen → nicht in den Warenkorb legen, Hinweis zeigen
  document.addEventListener(
    'submit',
    (event) => {
      if (!event.target || event.target.getAttribute('id') !== ROOT.dataset.formId) return; // nicht .id (Feld name="id")
      const needed = PROPS ? [1, 2, 3, 4].slice(0, state.mode) : state.mode === 4 ? [3, 4] : [];
      const missing = needed.filter((slot) => !valueOf(slot));
      if (!missing.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      state.active = missing[0];
      syncAll();
      showError(missing);
      (document.querySelector('[data-mavo-slots]') || ROOT).scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    true
  );

  // Nach dem Neuladen der Varianten-Auswahl (Farbe #1/#2) Farben und Paletten neu abgleichen
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      syncAll();
    });
  }).observe(document.querySelector('product-info') || document.body, { childList: true, subtree: true });

  window.mavoColors.onChange(syncAll);
  document.body.classList.toggle('mavo-props', PROPS);
  applyPattern();
  syncAll();
  mountStage();
}
